import clsx from 'clsx';

export const GeolocationWrapModal = ({ isOpen, image, children }) => {
  return (
    <>
      <div
        className={clsx(
          "fixed top-0 left-0 w-full h-full bg-black bg-opacity-50 z-[1800] transition-opacity duration-300",
          {
            "opacity-100": isOpen,
            "opacity-0 pointer-events-none": !isOpen
          }
        )}/>

      <div
        className={clsx(
          "fixed top-1/2 left-1/2 transform -translate-x-1/2 flex flex-col justify-center items-center -translate-y-1/2 bg-white rounded-2xl p-8 z-[1801] w-[90vw] transition-all duration-500",
          {
            "opacity-100 scale-100": isOpen,
            "opacity-0 scale-75 pointer-events-none": !isOpen
          }
        )}
        style={{
          transitionTimingFunction: 'cubic-bezier(0.68, -0.55, 0.265, 1.55)',
          maxWidth: '450px'
        }}
      >
        <div className="flex justify-center items-center">
          <img src={image} alt="wrongStorePikko" className="w-28 h-28" />
        </div>

        {children}
      </div>
    </>
  );
};
